export default [
  'armor_special_ks2019',
  'back_special_heroicAureole',
  'background_airship',
  'background_clocktower',
  'background_steamworks',
  'broad_armor_special_0',
  'broad_armor_special_1',
  'broad_armor_special_ks2019',
  'eyewear_special_ks2019',
  'head_special_0',
  'head_special_1',
  'head_special_ks2019',
  'Mount_Body_Gryphon-Gryphatrice',
  'Mount_Head_Gryphon-Gryphatrice',
  'Pet_HatchingPotion_Cryptid',
  'Pet_HatchingPotion_Dessert',
  'Pet_HatchingPotion_Fungi',
  'Pet_HatchingPotion_Veggie',
  'Pet_HatchingPotion_VirtualPet',
  'Pet_HatchingPotion_Windup',
  'Pet-Gryphatrice-Jubilant',
  'Pet-Gryphon-Gryphatrice',
  'Pet-Wolf-Cerberus',
  'quest_solarSystem',
  'quest_virtualpet',
  'quest_windup',
  'shield_special_0',
  'shield_special_ks2019',
  'shop_armoire',
  'slim_armor_special_0',
  'slim_armor_special_1',
  'slim_armor_special_ks2019',
  'stable_Pet-Gryphatrice-Jubilant',
  'stable_Pet-Gryphon-Gryphatrice',
  'stable_Pet-Wolf-Cerberus',
  'weapon_special_0',
  'weapon_special_critical',
  'weapon_special_ks2019',
];
